export const tabs = ({ caseMenu: { tabs: data } }) => data.map((item, index) => ({
  ...item,
  id: index,
}));



// WEBPACK FOOTER //
// ./src/store/selectors/caseMenu.js